import { defineFcm } from '../shared/factory';

export const FCM_CORGI_FRAME_RELAUNCH = defineFcm('corgi_frame_relaunch').asBoolean().withDefault(false).toConfig();
